import { Stack } from '@mui/material';

import WhatsAppIcon from 'assets/images/WhatsAppIcon';
import PageHeader from 'domains/core/components/PageHeader';
import { ContentStatus } from 'pages/ContentPage/ContentTable/ContentStatusText/ContentStatusText';

import SaveAndExitButton from './SaveAndExitButton';

type WhatsAppHeaderSectionProps = {
    isLoading: boolean;
    onSaveAndExit: (status?: ContentStatus) => void;
    content: string;
};

const WhatsAppHeaderSection = ({ isLoading, onSaveAndExit, content }: WhatsAppHeaderSectionProps) => (
    <PageHeader
        icon={<WhatsAppIcon fontSize="inherit" />}
        header="whatsapp message"
        headerOthers={
            <Stack direction="row" justifyContent="flex-end" width="100%" alignItems="center">
                <SaveAndExitButton isLoading={isLoading} onSaveAndExit={onSaveAndExit} content={content} />
            </Stack>
        }
    />
);

export default WhatsAppHeaderSection;
